import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Catches render-time errors in its subtree and shows a recoverable fallback
 * instead of unmounting the whole app. Error boundaries must be class
 * components (no hook equivalent exists).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Render error caught by ErrorBoundary:', error, info);
  }

  handleReset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[16rem] gap-4 px-6 text-center">
          <p className="text-lg font-semibold" style={{ color: 'var(--dm-ink)' }}>Something went wrong.</p>
          <p className="text-sm" style={{ color: 'var(--dm-muted)' }}>
            An unexpected error occurred while rendering this page.
          </p>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 text-sm font-medium text-white"
              style={{ backgroundColor: 'var(--dm-ink)', borderRadius: 'var(--dm-r)' }}
            >
              Reload
            </button>
            <Link
              to="/"
              onClick={this.handleReset}
              className="px-4 py-2 text-sm font-medium"
              style={{ border: '1px solid var(--dm-border)', borderRadius: 'var(--dm-r)', color: 'var(--dm-ink)' }}
            >
              Go home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
